<fluent-tabs activeid="entrees">
  <fluent-tab id="usuarios" (click)="setDatatableModal('usuarios')"
    >Usuarios</fluent-tab
  >
  <fluent-tab id="roles" (click)="setDatatableModal('roles')">Roles</fluent-tab>
  <fluent-tab id="grupos" (click)="setDatatableModal('grupos')"
    >Grupos</fluent-tab
  >
  <fluent-tab-panel id="usuariosPanel">
    <ol>
      <table
        datatable
        [dtOptions]="dtOptionsUsuarios"
        [dtTrigger]="dtTriggerUsuario"
        class="ms-Table ms-Table--selectable order-column row-border"
        style="width: 100%"
        id="datatableUsuarios"
      ></table>
    </ol>
  </fluent-tab-panel>
  <fluent-tab-panel id="rolesPanel">
    <ol>
      <table
        datatable
        [dtOptions]="dtOptionsRoles"
        [dtTrigger]="dtTriggerRol"
        class="ms-Table ms-Table--selectable order-column row-border"
        style="width: 100%"
        id="datatableRoles"
      ></table>
    </ol>
  </fluent-tab-panel>
  <fluent-tab-panel id="gruposPanel">
    <ol>
      <table
        datatable
        [dtOptions]="dtOptionsGrupos"
        [dtTrigger]="dtTriggerGrupo"
        class="ms-Table ms-Table--selectable order-column row-border"
        style="width: 100%"
        id="datatableGrupos"
      ></table>
    </ol>
  </fluent-tab-panel>
</fluent-tabs>



<button
  class="ms-Button ms-Button--primary"
  type="button"
  id="btnAddPermission"
  (click)="abrirDataTableModal()"
>
  <span class="ms-Button-label" id="spanAddPermission">Agregar Usuario</span>
</button>

<div class="ms-Dialog-actions" [hidden]="botonProcesando">
  <button type="button" class="ms-Button ms-Dialog-action" *ngIf="cancelButton">
    Cancelar
  </button>
  <button
  *ngIf="!cancelButton && !idReceivedMenu"
  class="ms-Button"
  type="button"
  id="btnReturnProcess"
  (click)="abrirDatatableProcesos()"
>
  <span class="ms-Button-label" id="spanReturnProcess">Volver a Procesos</span>
</button>
<button
*ngIf="!cancelButton && idReceivedMenu"
class="ms-Button"
type="button"
id="btnReturnProcess"
(click)="abrirDatatablePermisosMenu()"
>
<span class="ms-Button-label" id="spanReturnProcess">Volver a Menu</span>
</button>
  <div style="float: right">
    <button class="ms-Button ms-Button--primary" (click)="abrirModalPermisos()">
      <span class="ms-Button-label">Guardar permisos</span>
    </button>
  </div>
</div>

<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-permisos-usuario" style="width:50rem;" appPreventOutsideClick>
    <div id="divModalPermisosUsuario" class="ms-Dialog-title">
      Agregar Usuario
    </div>
    <app-data-table isExcludedData ="usuarios" isNotifyData="true" tableId="datatablePermisosUsuario" [serverSide]="true" [serverData]="getUsuarios" [claseBoton]="'pruebausuario'"  [columns]="columnasUsuario" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtonsPermisosUsuarios" ></app-data-table>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button
        class="ms-Button ms-Button--primary"
        type="button"
        (click)="closeDataTableModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
   
    </div>
  </div>
</div>
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-permisos-rol" style="width:50rem;" appPreventOutsideClick>
    <div id="divModalPermisosRol" class="ms-Dialog-title">Agregar Rol</div>
    <app-data-table  isExcludedData ="roles"  isNotifyData="true" tableId="datatablePermisosRol" [serverSide]="true" [claseBoton]="'pbaRol'" [serverData]="getRoles" [internalReload]="false" [columns]="columnasRol" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtonsPermisosRol" ></app-data-table>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button
        class="ms-Button ms-Button--primary"
        type="button"
        (click)="closeDataTableModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
      
    </div>
  </div>
</div>
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-permisos-grupo"style="width:50rem;" appPreventOutsideClick>
    <div id="divModalPermisosGrupo" class="ms-Dialog-title">Agregar Grupo</div>
    <app-data-table   isExcludedData ="grupos" isNotifyData="true" tableId="datatablePermisosGrupo" [serverSide]="true" [claseBoton]="'pbaGrupo'" [serverData]="getGrupos" [columns]="columnasGrupo" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtonsPermisosGrupo" ></app-data-table>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button
        class="ms-Button ms-Button--primary"
        type="button"
        (click)="closeDataTableModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>

    </div>
  </div>
</div>

<!-- Modal Confirmacion Permisos -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader guardar-permisos" appPreventOutsideClick>
    <div class="ms-Dialog-title" *ngIf="idReceived">Guardar Permisos del Proceso</div>
    <div class="ms-Dialog-title" *ngIf="idReceivedMenu">Guardar Permisos del menu</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">¿Desea guardar los permisos?</p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
      <button *ngIf="idReceived"
        (click)="enviarPermisosProceso()"
        class="ms-Button ms-Dialog-action ms-Button--primary"
      >
        <span class="ms-Button-label">Guardar</span>
      </button>
      <button *ngIf="idReceivedMenu"
        (click)="enviarPermisosMenu()"
        class="ms-Button ms-Dialog-action ms-Button--primary"
      >
        <span class="ms-Button-label">Guardar</span>
      </button>
    </div>
  </div>
</div>

<!-- Modal Confirmacion Remover Elemento -->
<div class="docs-DialogExample-lgHeader info">
  <div class="ms-Dialog ms-Dialog--lgHeader eliminar-permisos" >
    <div class="ms-Dialog-title">Eliminar elemento</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">¿Está seguro que desea eliminar el {{ groupDelete }} ?</p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" (click)="cancelElementRemove()" class="ms-Button ms-Dialog-action">Cancelar</button>
      <button 
        (click)="removeElement()"
        class="ms-Button ms-Dialog-action ms-Button--primary"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>

<!-- Modal Regreso Datatable -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader datatable-procesos" appPreventOutsideClick>
    <div class="ms-Dialog-title" *ngIf="idReceived">Permisos del Proceso guardados</div>
    <div class="ms-Dialog-title" *ngIf="idReceivedMenu">Permisos del Menu guardados</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText" *ngIf="idReceived">
        Permisos del Proceso almacenados exitosamente
      </p>
      <p class="ms-Dialog-subText" *ngIf="idReceivedMenu">
        Permisos del Menu almacenados exitosamente
      </p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="abrirDatatableProcesos()"
        *ngIf="idReceived"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="abrirDatatablePermisosMenu()"
        *ngIf="idReceivedMenu"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify>
